

import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { BaseService } from './base.service'
import { UserRoleModel } from './commonModel'
//import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';
//import { Observable } from 'rxjs/Observable';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/toPromise';
//import { environment } from '../../../environments/environment';

import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';

@Injectable()
export class CommonService {

  apiURL: string;
  roleObj = <UserRoleModel>{};
  public menuList: RouteInfo[]=[];
  loginid = localStorage.getItem("username");
  UserType = localStorage.getItem("UserType");

  constructor(private router: Router, private baseservice: BaseService) {
    const menuItem: RouteInfo = {
      icon: "ft-home",
      badge: "",
      title: "Dashboard",
      badgeClass: "",
      path: "/dashboard/dashboard",
     // path: "",
      isExternalLink: false,
      submenu: [],
      Class: ""
    };

    const logoutItem: RouteInfo = {
      icon: "ft-log-out",
      badge: "",
      title: "Logout",
      badgeClass: "",
      path: "/logout",
      isExternalLink: false,
      submenu: [],
      Class: ""
    };
    
    this.getLeftMenu()
      .subscribe(menu => {
        debugger
        this.menuList = menu;
        if (this.UserType != "D" && this.loginid != 'CUS001847') {
          this.menuList.splice(0, 0, menuItem);
        }
        if (this.UserType == "D") {
          this.menuList.push(logoutItem);
        }
      });
  }

  //----------------Check Authentication -------------------------------------
  checkIsAuthenticated() {
    var username = localStorage.getItem('UserName');
    if (username == null || username == "") {
      this.router.navigateByUrl('/auth/login');
    }
    else {
    }

  }



  //------------left menu------------------
  getLeftMenu() {
    return this.baseservice.getDataList('C_MenuMaster/GetLeftMenuData?UserId=' + this.loginid);
  }


  //------------ get User Role------------------
  public getUserRole(username: string) {
    return this.baseservice.getDataList('AspNetUser/GetRoleUser?UserId=' + username);
  }


  formatDate(date: Date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }


  //------------get DashBoard------------------
  getDashbordDetail(LoginId: String, BusinessCategoryList: string[]) {

    const categories = BusinessCategoryList.join(',');
    const encodedCategories = encodeURIComponent(categories);
    //return this.baseservice.getDataList('dashboard/GetDashbordDetail?LoginId=' + LoginId + '&BusinessCategoryList=' + encodedCategories);
    return this.baseservice.getDataList('Report/DashboardReport?LoginId=' + LoginId + '&BusinessCategoryList=' + encodedCategories);

  }

  getInquiryDashbordDetail(LoginId: String, Role: string, BusinessCategory: BigInteger) {
    return this.baseservice.getDataList('Dashboard/GetInquiryDashbordDetail?LoginId=' + LoginId + "&Role=" + Role);
  }
}
